import React from 'react';
import PropTypes from 'prop-types';

import {Paper, Typography, Stack, Timeline} from 'views/components';
import {HistoryOutlined as HistoryOutlinedIcon} from 'views/icons';
import {Translate} from 'views/module';

import RecordCreation from './timeline/RecordCreation';
import ShiftClockedIn from './timeline/ShiftClockedIn';
import ShiftClockedOut from './timeline/ShiftClockedOut';
import ShiftConfirmed from './timeline/ShiftConfirmed';
import ShiftCancelled from './timeline/ShiftCancelled';
import ShiftRescheduled from './timeline/ShiftRescheduled';

const EventTimelineTile = (props) => {
  const {event, setModel} = props;

  const [timeline, setTimeline] = React.useState([]);

  const caregiverUpdates = event.caregiverUpdates;

  React.useEffect(() => {
    const timelineEvents = [
      {
        date: event.createdAt,
        element: <RecordCreation createdAt={event.createdAt} key="created" />,
      },
    ];

    for (const caregiverUpdate of caregiverUpdates) {
      if (caregiverUpdate.type === 'shiftConfirmation') {
        timelineEvents.push({
          date: caregiverUpdate.createdAt,
          element: <ShiftConfirmed confirmation={caregiverUpdate} caregiverData={event.caregiverData} key="shiftConfirmed" />,
        });
      } else if (caregiverUpdate.type === 'clockInConfirmation') {
        timelineEvents.push({
          date: caregiverUpdate.createdAt,
          element: <ShiftClockedIn clockIn={caregiverUpdate} caregiverData={event.caregiverData} key="clockIn" />,
        });
      } else if (caregiverUpdate.type === 'clockOutConfirmation') {
        const answers = caregiverUpdate.data.answers;
        timelineEvents.push({
          date: caregiverUpdate.createdAt,
          element: <ShiftClockedOut clockOut={caregiverUpdate} caregiverData={event.caregiverData} answers={answers} key="clockOut" />,
        });
      } else if (caregiverUpdate.type === 'requestReschedule') {
        timelineEvents.push({
          date: caregiverUpdate.createdAt,
          element: <ShiftRescheduled
            setModel={setModel}
            reschedule={caregiverUpdate}
            caregiverData={event.caregiverData}
            key="requestReschedule"
          />,
        });
      } else if (caregiverUpdate.type === 'requestCancel') {
        timelineEvents.push({
          date: caregiverUpdate.createdAt,
          element: <ShiftCancelled
            setModel={setModel}
            cancellation={caregiverUpdate}
            caregiverData={event.caregiverData}
            key="requestCancel"
          />,
        });
      }
    }

    const sortedTimeline = timelineEvents.sort((a, b) => new Date(b.date) - new Date(a.date));

    setTimeline(sortedTimeline);
  }, [caregiverUpdates]);


  return (
    <Paper sx={{border: '1px solid', borderColor: 'grey.200', borderRadius: 2, flex: 1}}>
      <Stack direction="row" alignItems="center" spacing={1} mb={2} p={2}>
        <HistoryOutlinedIcon sx={{width: 24, height: 24, color: 'grey'}} />
        <Typography variant="subtitle2" sx={{fontWeight: 700, fontSize: 16, display: 'flex', alignItems: 'center', mb: 0}}>
          <Translate expression='eventList.EventTimelineSection.Title' />
        </Typography>
      </Stack>
      <Timeline
        position="right"
      >
        {timeline.map((e) => e.element)}
      </Timeline>
    </Paper>
  );
};

EventTimelineTile.propTypes = {
  event: PropTypes.object.isRequired,
  setModel: PropTypes.func.isRequired,
};

export default EventTimelineTile;
